import { Component, Input, OnInit } from "@angular/core";

import { Router } from "@angular/router";
import { AppConsts } from "../../app-consts";

@Component({
  selector: "app-language-switcher",
  templateUrl: "./language-switcher.component.html",
  styleUrls: ["./language-switcher.component.css"]
})
export class LanguageSwitcherComponent implements OnInit {
  @Input('currentLang') currLang: string;
  constructor(
    private router: Router
  ) { }

  ngOnInit() { }

  switchLanguage() {
    if (this.currLang) {
      if (this.currLang === "ar") {
        sessionStorage.setItem(AppConsts.Session_Lang, 'en');
        let url = this.router.url.replace(this.currLang, 'en')
        window.location.replace(url)
      } else if (this.currLang === "en") {
        sessionStorage.setItem(AppConsts.Session_Lang, 'ar');
        let url = this.router.url.replace(this.currLang, 'ar')
        window.location.replace(url)
      }
    }
  }
}
